<div class="ai-assistant-container">
    <iframe
        [src]="bourneUrl"
        width="100%"
        height="100%"
        frameborder="0"
        title="AI Assistant"
        style="border: none; display: block"
    ></iframe>
</div>
